angular.module('autoremind.templates')
    .directive('adminTemplatesAr2All', ['templateAr2Service', '$uibModal', '$timeout', 'userSettings',
    function (templateAr2Service, $uibModal, $timeout, userSettings) {
        return {
            restrict: 'E',
            templateUrl: 'app/admin/templates/admin-templates-ar2-all.html',
            scope: {
                userId: '='
            },
            link: function ($scope, element, attrs) {
                console.log('adminTemplatesAr2All');
                element.addClass('adminTemplatesAll');
                $scope.templateAr2Service = templateAr2Service;
                $scope.userSettings = userSettings;
                $scope.$watch('userId', function (newVal, oldVal) {
                    $scope.templateAr2Service.userModel.userId = newVal;
                    $scope.filterWasChanged(true);
                });
                $scope.templateTypes = [{
                        name: 'all',
                        label: 'All'
                    }, {
                        name: 'email',
                        label: 'Email'
                    }, {
                        name: 'sms',
                        label: 'Sms'
                    }, {
                        name: 'voice',
                        label: 'Voice'
                    }];
                $scope.init = function () {
                    templateAr2Service.getLanguages();
                }();
                $scope.changeSorting = function (column) {
                    if (userSettings.model.ar2filters.sortby === column) {
                        userSettings.model.ar2filters.order = !userSettings.model.ar2filters.order;
                    }
                    else {
                        userSettings.model.ar2filters.sortby = column;
                        userSettings.model.ar2filters.order = false;
                    }
                    $scope.filterWasChanged(true);
                };
                var _timeout;
                $scope.filterWasChanged = function (isNoNeedTimeout) {
                    if (_timeout) {
                        $timeout.cancel(_timeout);
                    }
                    if (isNoNeedTimeout) {
                        _timeout = null;
                        $scope.templateAr2Service.resetFilters();
                        return;
                    }
                    _timeout = $timeout(function () {
                        _timeout = null;
                        $scope.templateAr2Service.resetFilters();
                    }, 1000);
                };
                $scope.loadTemplates = function () {
                    templateAr2Service.getTemplates();
                };
                $scope.upload = function (template) {
                    $scope.selectTemplate(template);
                    if (template.countOfTemplateFileUsages > 0) {
                        $scope.templateAr2Service.showErrorIfFileIsUsed()
                            .then(function () {
                            $scope.uploadTemplate(template, true);
                        });
                        return;
                    }
                    $scope.uploadTemplate(template);
                };
                $scope.deleteTemplate = function (template) {
                    $scope.selectTemplate(template);
                    if (template.countOfTemplateFileUsages > 0) {
                        $scope.templateAr2Service.showErrorIfFileIsUsed(true);
                        return;
                    }
                    $scope.templateAr2Service.deleteTemplate(template)
                        .then(function () {
                        $scope.filterWasChanged(true);
                    });
                };
                $scope.uploadTemplate = function (template, isCustomTemplate) {
                    var modalInstance;
                    var modalScope = $scope.$new();
                    modalScope.template = angular.isDefined(template) ? template : {};
                    modalScope.isCustomTemplate = isCustomTemplate;
                    modalScope.success = function () {
                        modalInstance.close(modalScope.selected);
                    };
                    modalScope.cancel = function () {
                        modalInstance.dismiss('cancel');
                    };
                    modalInstance = $uibModal.open({
                        template: '<template-ar2-upload></template-ar2-upload>',
                        size: 'lg',
                        backdrop: 'static',
                        scope: modalScope
                    });
                };
                $scope.previewEditTemplateDialog = function (template) {
                    var templateData = {
                        fileName: template.file,
                        type: template.type,
                        sourceOfTemplate: angular.copy(template)
                    };
                    $scope.templateAr2Service.previewEditTemplateDialog(templateData);
                };
                $scope.hidingFilter = function (template) {
                    return $scope.templateAr2Service.hidingFilter(template);
                };
                $scope.selectTemplate = function (template) {
                    $scope.templateAr2Service.currentTemplate = angular.copy(template);
                };
            }
        };
    }]);
//# sourceMappingURL=admin-templates-ar2-all.js.map